// extracted by mini-css-extract-plugin
export var categories = "index-module--categories--Sd4WL";
export var isActive = "index-module--isActive--SUUov";